/**
 * Regions a platform (or sub-platform) can be tagged with in the catalog. Saved on the platform as
 * `{ code, nameFr, nameEn }`; the code is what the tender API's coverage matches on. The names are
 * spelled out here rather than read from the zone filter's translations: they get stored, and
 * translations are UI copy (locale fallback, tenant terminology), not data.
 * `CA` marks a national platform. Provinces and territories follow the usual west-to-east order.
 */
export const PLATFORM_REGIONS = Object.freeze([
  { code: 'CA', nameFr: 'Canada', nameEn: 'Canada' },
  { code: 'BC', nameFr: 'Colombie-Britannique', nameEn: 'British Columbia' },
  { code: 'AB', nameFr: 'Alberta', nameEn: 'Alberta' },
  { code: 'SK', nameFr: 'Saskatchewan', nameEn: 'Saskatchewan' },
  { code: 'MB', nameFr: 'Manitoba', nameEn: 'Manitoba' },
  { code: 'ON', nameFr: 'Ontario', nameEn: 'Ontario' },
  { code: 'QC', nameFr: 'Québec', nameEn: 'Quebec' },
  { code: 'NB', nameFr: 'Nouveau-Brunswick', nameEn: 'New Brunswick' },
  { code: 'NS', nameFr: 'Nouvelle-Écosse', nameEn: 'Nova Scotia' },
  { code: 'PE', nameFr: 'Île-du-Prince-Édouard', nameEn: 'Prince Edward Island' },
  { code: 'NL', nameFr: 'Terre-Neuve-et-Labrador', nameEn: 'Newfoundland and Labrador' },
  { code: 'YT', nameFr: 'Yukon', nameEn: 'Yukon' },
  { code: 'NT', nameFr: 'Territoires du Nord-Ouest', nameEn: 'Northwest Territories' },
  { code: 'NU', nameFr: 'Nunavut', nameEn: 'Nunavut' },
]);
